export const FILE_TYPE = {
    PROJECT : 1,
    COMPANY : 2,
    INVOICE : 3,
    RECEIPT : 4,
    MAIN : 5,
    TEMPLATE : 6,
}